module.exports = __webpack_public_path__ + "media/img/flags/Mexico-6f3f2e315d687768372fe3e223590676.png";